import React from "react"
import PropTypes from "prop-types"
import { MediaPreview } from "ui/MediaPreview"
import Masonry from "react-masonry-css"
import { Icon } from "ui/Icon"
import { colors } from "themes/variables"
import styles from "./MediaGrid.module.css"

const renderMedia = (media, index, onImageClick, withActions, onDelete) => {
  return (
    <div className={styles.mediaWrapper}>
      <MediaPreview
        media={media}
        onClick={() => {
          onImageClick?.(index)
        }}
        objectFit="cover"
      />
      {withActions && (
        <div
          className={styles.actionWrapper}
          onClick={(e) => {
            e.stopPropagation()
            onDelete?.(index)
          }}
        >
          <Icon type="feather" name="X" width={16} height={16} strokeWidth={2} color={colors.textSecondary} />
        </div>
      )}
    </div>
  )
}

const MediaGrid = ({ mediaItems = [], onImageClick, withActions = false, onDelete }) => {
  if (mediaItems.length === 0) return null

  const breakpointColumns = {
    default: 4,
    1200: 3,
    768: 2,
    576: 1
  }

  return (
    <Masonry
      breakpointCols={breakpointColumns}
      className={styles.masonryGrid}
      columnClassName={styles.masonryGridColumn}
    >
      {mediaItems.map((media, index) => (
        <div key={media.id || index} className={styles.masonryItem}>
          {renderMedia(media, index, onImageClick, withActions, onDelete)}
        </div>
      ))}
    </Masonry>
  )
}

MediaGrid.propTypes = {
  mediaItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      placeholder_url: PropTypes.string
    })
  ).isRequired,
  onImageClick: PropTypes.func,
  withActions: PropTypes.bool,
  onDelete: PropTypes.func
}

export { MediaGrid }
